module.exports = __webpack_public_path__ + "static/media/gal2.fe102163.JPG";